import { useEffect, useRef } from "react";
import { authFetch } from "../../App";
import { toast } from "sonner";
import { Eye, Pencil, Copy, Trash2 } from "lucide-react";
import { API } from "./helpers";

export function RowContextMenu({ x, y, contact, onClose, onSelect, onEdit, onDelete, onRefresh }) {
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  const handleDuplicate = async () => {
    onClose();
    const res = await authFetch(`${API}/crm/contacts/${contact.id}`);
    if (!res.ok) return;
    const orig = await res.json();
    const { id, kundennummer, letzte_aktivitaet, ...rest } = orig;
    const createRes = await authFetch(`${API}/crm/contacts`, {
      method: "POST", body: JSON.stringify({ ...rest, firma: `${rest.firma || ""} (Kopie)` }),
    });
    if (createRes.ok) { toast.success("Kontakt dupliziert"); onRefresh(); }
  };

  const handleDelete = async () => {
    onClose();
    if (!window.confirm(`"${contact.firma || "Kontakt"}" wirklich löschen?`)) return;
    const res = await authFetch(`${API}/crm/contacts/${contact.id}`, { method: "DELETE" });
    if (res.ok) { toast.success("Kontakt gelöscht"); onDelete(contact.id); }
  };

  const items = [
    { label: "Anzeigen", icon: Eye, action: () => { onClose(); onSelect(contact.id); } },
    { label: "Bearbeiten", icon: Pencil, action: () => { onClose(); onEdit(contact.id); } },
    { divider: true },
    { label: "Duplizieren", icon: Copy, action: handleDuplicate },
    { divider: true },
    { label: "Löschen", icon: Trash2, action: handleDelete, danger: true },
  ];

  return (
    <div
      ref={ref}
      className="fixed z-[9999] bg-white border border-gray-200 rounded-md shadow-lg py-1 min-w-[160px]"
      style={{ top: y, left: x }}
      data-testid="row-context-menu"
    >
      {items.map((item, i) =>
        item.divider ? (
          <div key={i} className="border-t border-gray-100 my-0.5" />
        ) : (
          <div
            key={i}
            className={`px-3 py-1.5 text-[11px] cursor-pointer flex items-center gap-2 ${
              item.danger ? "text-red-600 hover:bg-red-50" : "text-gray-700 hover:bg-gray-50"
            }`}
            onClick={item.action}
            data-testid={`ctx-${item.label.toLowerCase().replace(/[^a-z]/g, "")}`}
          >
            <item.icon className="w-3.5 h-3.5" />
            {item.label}
          </div>
        )
      )}
    </div>
  );
}
